<template>
    <div class="gp-ci">
        <div class="gp-ci__container">
            <TitleText class="spacing-b-6" level="2">
                {{ $ml.get('titleViewGooglePay') }}
            </TitleText>

            <GooglePayButton
                v-show="false"
                ref="gpButton"
            />

            <GooglePaySelectedCard
                :google-pay-selected-card-description="googlePaySelectedCardDescription"
                @buttonClicked="handleButtonClick"
            />
            <CieloSelect
                @change="selectItem"
                :title="$ml.get('installment')"
                name="selectInstallment"
                :label="$ml.get('installmentsNumber')"
                :option-items="installmentList || undefined"
                :selected-item="numberOfInstallments"
                :on-get-item-event="getLangOptions"
                :disabled="!paymentMethodImage || this.installmentIsFixed"
            />
        </div>

        <div class="gp-ci__cta-container">
            <ButtonsNextPrevious
                :disable-button-next="disableButtonNext"
                :back-text="'changePayment'"
                @click-next="goToNextStep"
                @click-previous="goToPreviousStep"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { Token, Options } from '@/config/lang/genericOptions.js';
    import { logEvent } from '@/helpers/cieloLogger';
    import ButtonsNextPrevious from '@/components/template/ButtonsNextPrevious';
    import CieloSelect from '@/components/template/CieloSelect/CieloSelect';
    import GooglePaySelectedCard from '@/components/GooglePaySelectedCard';
    import GooglePayButton from '@/components/GooglePayButton';
    import TitleText from '@/components/template/TitleText';

export default {

    components: {
        ButtonsNextPrevious,
        CieloSelect,
        GooglePaySelectedCard,
        GooglePayButton,
        TitleText
    },

    data() {
        return {
            selectedCard: '',
            defaultBins: {
                AMEX: 377467,
                DISCOVER: 601102,
                JCB: 358292,
                VISA: 462294,
                MASTERCARD: 518600,
                ELO: 650505,
                // INTERAC: 0,
            }
        };
    },

    computed: {
        ...mapGetters({
            installmentList: 'payment/getInstallmentListForPaymentMethodSelected',
            selectedPaymentMethod: 'payment/getSelectedPaymentMethod',
            googlePaySelectedCard: 'googlePayPayment/getSelectedCard',
            googlePaySelectedCardDescription: 'googlePayPayment/getSelectedCardDescription',
            installmentIsFixed: 'payment/getSelectedPaymentMethodInstallmentIsAbleToBeFixed'
        }),

        numberOfInstallments: {
            get: (self) =>
                self.$store.getters['payment/getInstallmentNumberOfPayments'],
            set(value) {
                this.$store.commit('payment/setNumberOfInstallments', value);
            },
        },

        paymentMethodImage: (self) => {
            return self.selectedPaymentMethod ? self.selectedPaymentMethod.Image : null;
        },

        disableButtonNext() {
            if (!this.selectedCard || !this.numberOfInstallments) {
                return true;
            }

            return false;
        },
    },

    created() {
        this.selectedCard = this.googlePaySelectedCard;
        this.doBinQuery();
    },

    watch: {
        googlePaySelectedCard() {
            this.selectedCard = this.googlePaySelectedCard;
            this.doBinQuery();
        },
    },

    methods: {
        async doBinQuery() {
            try {
                await this.$store.dispatch('googlePayPayment/fetchCardBrand', this.defaultBins[this.selectedCard.info.cardNetwork]);

                return true;
            }
            catch (error) {
                logEvent({
                    category: 'BinQuery',
                    action: 'Do Bin Query',
                    label: `[BIN QUERY ERROR]: ${error}`
                });

                return false;
            }
        },

        goToNextStep() {
            logEvent({
                category: 'google_pay',
                action: 'parcelas_compra_gpay',
                label: 'Usuário escolhe a quantidade de parcelas.'
            });
            this.$store.dispatch('pipeline/pushTo', 'GooglePayBillingAddress');
        },

        goToPreviousStep() {

            logEvent({
                category: 'google_pay',
                action: 'troca_forma_pagamento_gpay',
                label: 'Na tela de escolha de parcela usuario escolhe trocar a forma de pagamento.'
            });
            this.$store.commit('payment/setNumberOfInstallments', 0);
            this.$store.commit('googlePayPayment/clearSelectedCard');
            this.$store.dispatch('pipeline/pushPrevious');
        },
        

        selectItem(item) {
            this.numberOfInstallments = item;
        },

        getLangOptions(item) {
            let tokens = [];

            tokens.push(new Token('quantity', item.Value));
            tokens.push(new Token('installmentPrice', item.installmentPrice));

            return new Options('installmentsItem', tokens);
        },

        handleButtonClick() {
            let element = this.$refs.gpButton.$el.querySelector('button');

            if(element) element.click();
        },
    },
};
</script>
<style lang='scss' scoped>
    .gp-ci {

      @media screen and (max-width: 1024px) {
          display: flex;
          flex-direction: column;
          flex: 1 0 auto;
      }

      &__container {
          margin-bottom: 24px;
          
          @media screen and (max-width: 1024px) {
              flex: 1;
          }
      }

      &__cta-container {}

      .gp-selected-card {
          margin-bottom: 20px;
      }
    }
</style>
